module.exports = __webpack_public_path__ + "img/ANTENNA 5 LIME.bce95b7.svg";